import { Box, Button, Stack, TextField, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Style } from "../../types/Artist";

type StyleRowProps = {
    index: number,
    style: Style,
    handleDelete: (index: number) => void,
    handleChange: (index: number, style: Style) => void,
}

const StyleRow = (props: StyleRowProps) => {
    const [ style, setStyle ] = useState<Style>(props.style);
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        if (props.style.key !== '' && props.style.key !== style.key) {
            setStyle(props.style);
        }
    }, [ props.style, style.key ]);

    useEffect(() => {
        props.handleChange(props.index, style);
    }, [ style ]);
    
    const handleKeyChange = (e: string) => setStyle({ ...style, key: e });
    const handleValueChange = (e: string) => setStyle({ ...style, value: e });
    const handleDelete = () => props.handleDelete(props.index);

    return (
        <Box>
            <Stack direction="row" spacing={1}>
                <Box>
                    <TextField
                        sx={{ width: isSmall ? '120px' : '180px' }}
                        size="small"
                        label={`Style ${props.index + 1}`}
                        variant="outlined"
                        value={style.key}
                        onChange={(e) => handleKeyChange(e.target.value)}
                    />
                </Box>
                <Box>
                    <TextField
                        sx={{ width: isSmall ? '120px' : '240px' }}
                        size="small"
                        label={`Value ${props.index + 1}`}
                        variant="outlined"
                        value={style.value}
                        onChange={(e) => handleValueChange(e.target.value)}
                    />
                </Box>
                <Box>
                    <Button sx={{ my: 0.5 }} variant="outlined" size="small" onClick={handleDelete}>Delete</Button>
                </Box>
            </Stack>
        </Box>
    );
}

export default StyleRow;